import { FC, useState } from 'react';
import { Switch } from '@/components/ui/switch';

type Props = {
	label: string;
	icon: React.FC<React.SVGProps<SVGSVGElement>>;
	addition?: React.ReactNode;
	value?: boolean;
	onClick?: (newValue: boolean) => void;
};

const PermissionsListElement: FC<Props> = ({
	label,
	icon: Icon,
	addition,
	onClick,
	value,
}) => {
	const handleSwitchChange = (checked: boolean) => {
		onClick?.(checked);
	};

	return (
		<div className='py-3 flex items-center gap-2.5'>
			<Icon />
			<span className='text-sm text-popover-1000'>{label}</span>
			<div className='ml-auto flex items-center gap-2.5'>
				{addition}
				{value !== undefined && (
					<Switch
						id='two-factor-authentication'
						checked={value}
						onCheckedChange={handleSwitchChange}
					/>
				)}
			</div>
		</div>
	);
};

export default PermissionsListElement;
